import { Action } from 'redux';
import { List } from 'Immutable';
import Face from './face';

    function randomInt(max: number): number {
        return Math.floor(Math.random() * max);
    }

    export const NEW_GAME_ACTION: 'NEW_GAME_ACTION' = 'NEW_GAME_ACTION';
    export interface NewGameAction extends Action {
        type: 'NEW_GAME_ACTION'
    }
    export const newGame = (): NewGameAction => ({ type: 'NEW_GAME_ACTION' });
    
    export const ROLL_DICE_ACTION: 'ROLL_DICE_ACTION' = 'ROLL_DICE_ACTION';
    export interface RollDiceAction extends Action {
        type: 'ROLL_DICE_ACTION';
        diceIndices: [number, number, number, number, number];
    }

    export const rollDice = (): RollDiceAction => ({
        type: 'ROLL_DICE_ACTION',
        diceIndices: [randomInt(6), randomInt(6), randomInt(6), randomInt(6), randomInt(6)]
    });

    export const SELECT_SEVEN_ACTION: 'SELECT_SEVEN_ACTION' = 'SELECT_SEVEN_ACTION';
    export interface SelectSevenAction extends Action {
        type: 'SELECT_SEVEN_ACTION';
        seven: List<number>;
    }

    export const selectSeven = (seven: List<number>): SelectSevenAction => ({
        type: 'SELECT_SEVEN_ACTION',
        seven
    });

    export const REPLACE_SEVEN_ACTION: 'REPLACE_SEVEN_ACTION' = 'REPLACE_SEVEN_ACTION';
    export interface ReplaceSevenAction extends Action {
        type: 'REPLACE_SEVEN_ACTION';
        index: number;
        points: number;
    }

    export const replaceSeven = (index: number, points: number): ReplaceSevenAction => ({
        type: 'REPLACE_SEVEN_ACTION',
        index, points
    });

    export const PLACE_X_ACTION: 'PLACE_X_ACTION' = 'PLACE_X_ACTION';
    export interface PlaceXAction extends Action {
        type: 'PLACE_X_ACTION';
        index: number;
    }

    export const replaceX = (index: number): PlaceXAction => ({
        type: 'PLACE_X_ACTION',
        index
    });

    export const BUMP_VALUE_ACTION: 'BUMP_VALUE_ACTION' = 'BUMP_VALUE_ACTION';
    export interface BumpValueAction extends Action {
        type: 'BUMP_VALUE_ACTION';
        index: number;
        face: Face;
    }

    export const bumpValue = (index: number, face: Face): BumpValueAction => ({
        type: 'BUMP_VALUE_ACTION',
        index, face
    })
    
    export const PASS_BUMP_VALUE_ACTION: 'PASS_BUMP_VALUE_ACTION' = 'PASS_BUMP_VALUE_ACTION';
    export interface PassBumpValueAction extends Action {
        type: 'PASS_BUMP_VALUE_ACTION';
    }
    export const passBumpValue = (): PassBumpValueAction => ({ type: 'PASS_BUMP_VALUE_ACTION' });


    export type AppAction = NewGameAction | RollDiceAction | SelectSevenAction | ReplaceSevenAction | BumpValueAction | PassBumpValueAction | PlaceXAction;